/*global window, jQuery */
(function($) {

  'use strict';

  $(function() {

    $('.selectpicker').on('change', function(){
    	document.location.href = $(this).val();
    });
  	

  });

}(jQuery));
